if (!customElements.get('media-gallery')) {
  class ProductThumbnailVerticalSliderComponent extends SliderComponent {
    constructor() {
      super();
    }
  
    initPages() {
      this.isMobile = window.innerWidth < 1200;
      if(this.isMobile) {
        super.initPages()
      } else {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientHeight > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
        this.slidesPerPage = Math.floor((this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset);
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
      }
    }
  
    update() {
      if(this.isMobile) {
        super.update()
      } else {
        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    
        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = this.currentPage;
          this.pageTotalElement.textContent = this.totalPages;
        }
    
        if (this.currentPage != previousPage) {
          this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }}));
        }
    
        if (this.enableSliderLooping) return;
    
        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollTop === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }
    
        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
  
    isSlideVisible(element, offset = 0) {
      if(this.isMobile) {
        return super.isSlideVisible(element, offset);
      } else {
        const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
        return (element.offsetTop + element.clientHeight) <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
      }
    }
  
    onButtonClick(event) {
      if(this.isMobile) {
        super.onButtonClick(event);
      } else {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollTop + (step * this.sliderItemOffset) : this.slider.scrollTop - (step * this.sliderItemOffset);
        this.slider.scrollTo({
          top: this.slideScrollPosition
        });
      }
    }
  }
  
  customElements.define('product-thumbnail-vertical-slider-component', ProductThumbnailVerticalSliderComponent);
  
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 1200px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    connectedCallback() {
      updateProductMediaStatus(this);
      if (!this.dataset.disableLightbox) this.setupLightboxIntent();
    }

    disconnectedCallback() {
      this.lightboxController?.abort();
      if(this.lightbox) this.lightbox.destroy();
      this.lightbox = null;
      this.lightboxReady = null;
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, allowScrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      
      window.setTimeout(() => {
        if (this.elements.thumbnails || window.innerWidth < 1200) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (allowScrollIntoView && ((this.dataset.desktopLayout === "stacked" &&
        window.innerWidth >= 1200) ||
        (this.dataset.scrollUpMobile && window.innerWidth < 1200))) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail)) return;

      if(this.elements.thumbnails.slider.classList.contains('thumbnail-list--vertical') && window.innerWidth >= 1200) {
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
        addLoadedImageStatus(image);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }

    setupLightboxIntent() {
      this.lightboxController = new AbortController();
      const signal = this.lightboxController.signal;
      const prepare = event => {
        if (event.target.closest('.product__modal-opener--image')) this.ensureLightbox().catch(() => {});
      };
      ['pointerover', 'pointerdown', 'focusin'].forEach(type => this.addEventListener(type, prepare, {signal, passive:true}));
      this.addEventListener('click', event => {
        const opener = event.target.closest('.product__modal-opener--image');
        if (!opener || this.lightbox || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const index = [...this.querySelectorAll('.product__modal-opener--image')].indexOf(opener);
        this.ensureLightbox().then(lightbox => {
          if (lightbox && this.isConnected) lightbox.loadAndOpen(index, {gallery:this});
        }).catch(() => { if (this.isConnected) window.location.assign(opener.href); });
      }, {signal});
    }

    ensureLightbox() {
      if (this.lightbox) return Promise.resolve(this.lightbox);
      if (this.lightboxReady) return this.lightboxReady;
      const config = window.photoswipeUrls;
      const signal = this.lightboxController.signal;
      if (typeof PhotoSwipeLightbox === 'function' && typeof PhotoSwipe === 'function') {
        config.promise = Promise.resolve();
      }
      if (!config.promise) {
        config.promise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = config.lib;
          script.onload = () => { config.loaded = true; resolve(); };
          script.onerror = () => { script.remove(); config.promise = null; config.loaded = false; reject(new Error('Image viewer could not load')); };
          document.body.appendChild(script);
        });
      }
      this.lightboxReady = config.promise.then(() => {
        if (!this.isConnected || signal.aborted) return null;
        this.lightbox = new PhotoSwipeLightbox({
          gallery:this,
          children:'.product__modal-opener--image',
          pswpModule:PhotoSwipe,
          tapAction:(pt, event) => {
            if (event.target.classList.contains('pswp__img')) this.lightbox.pswp.next();
            else this.lightbox.pswp.close();
          }
        });
        this.lightbox.init();
        return this.lightbox;
      }).catch(error => { this.lightboxReady = null; throw error; });
      return this.lightboxReady;
    }
  });
}
